import { createSetJobsDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useJobsData = (params, dataFresh) => {
  return useGetAndSet("jobs", params, createSetJobsDataAction, dataFresh);
};
